import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { logoutUser } from "store/actions";
import FullPageLoader from "App/common/ui/FullPageLoader";

function Logout360(props) {
  useEffect(() => {
    props.logoutUser(true, "360");
  }, []);
  return <FullPageLoader />;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logoutUser
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Logout360);
